module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', [_vm._t("default"), _vm._v(" "), (_vm.storeRouteName && _vm.canStore) ? _c('router-link', {
    staticClass: "el-button el-button--success",
    attrs: {
      "to": {
        name: _vm.storeRouteName
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" "), _c('span', [_vm._v("Criar " + _vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), (_vm.editRouteName && _vm.item && _vm.canUpdate) ? _c('router-link', {
    staticClass: "el-button el-button--info",
    attrs: {
      "to": {
        name: _vm.editRouteName,
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-edit"
  }), _vm._v(" "), _c('span', [_vm._v("Editar")])]) : _vm._e(), _vm._v(" "), (_vm.backRoute) ? _c('back-button') : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b717aa70!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/list/Header.vue
// module id = 782
// module chunks = 2